















import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseModalFooter from './_base-modal-footer.vue';

@Component({
  name: 'BaseModalButtonsFooter',
  components: {
    BaseModalFooter,
  },
})
export default class BaseModalButtonsFooter extends Vue {
  @Prop({ default: false }) reverseButtonsMobile: boolean;
  hasLeftSlot() {
    return !!this.$slots.left;
  }
}
